import store from '../../store';
import Mentor from './mentor';
import Mentee from './mentee';
import Chat from '../../views/Chat.vue';
import EllyEbby from '../../views/EllyEbby.vue';
import TaskDetails from '../../views/TaskDetails.vue';
import UserProfile from '../../views/user/UserProfile.vue';
import NewUser from '../../views/user/NewUser.vue';

const userData = store.dispatch('getLoggedInUserData');
const UserRoutes = async () => {
  await userData;
  let User = [];

  if (store.state.User.type) {
    User = store.state.User.type === 3 ? Mentor : Mentee;
  }

  return [{
    path: '/app',
    // name: 'app',
    async component() {
      await userData;
      return store.state.User.type === 3
        ? import('../../views/mentor/MentorApp.vue')
        : import('../../views/mentee/MenteeApp.vue');
    },
    meta: {
      requiresLogin: true,
      requiresUserType: true,
    },
    children: [
      {
        path: '',
        name: 'app',
        async component() {
          await userData;
          return store.state.User.type === 3
            ? import('../../views/mentor/Home.vue')
            : import('../../views/mentee/Home.vue');
        },
        alias: 'default',
      },
      {
        path: 'settings',
        name: 'settings',
        async component() {
          await userData;
          return import('../../views/Settings.vue');
        },
      },
      {
        path: 'profile',
        name: 'profile',
        component: UserProfile,
      },
      {
        path: 'resources',
        name: 'resources',
        async component() {
          await userData;
          return store.state.User.type === 3
            ? import('../../views/mentor/Resources.vue')
            : import('../../views/mentee/Resources.vue');
        },
      },
      {
        path: 'new-user',
        alias: 'profile-settings',
        name: 'NewUser',
        component: NewUser,
      },
      {
        path: 'elly',
        alias: 'ebby',
        name: 'ellyebby',
        component: EllyEbby,
        props: { lgGrid: true },
      },
      {
        path: 'chat:id',
        name: 'chatView',
        component: Chat,
        props: true,
      },
      {
        path: 'task/:id',
        name: 'FullTaskDetails',
        component: TaskDetails,
        props: true,
      },
      ...User,
    ],
  }];
};

export default UserRoutes;
